export const getFileSize = (url) => {
  var fileSize = "";
  var http = new XMLHttpRequest();
  http.open("GET", url, false); // false = Synchronous

  http.send(null); // it will stop here until this http request is complete

  // when we are here, we already have a response, b/c we used Synchronous XHR

  if (http.status === 200) {
    fileSize = http.getResponseHeader("Content-Length");
  }
  return fileSize;
};

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const openInNewTab = (base64, filename, suffix) => {
  if (base64) {
    const blob = b64toBlob(base64);
    const blobUrl = URL.createObjectURL(blob);

    if (["png", "jpg", "jpeg", "htm", "html"].includes(suffix)) {
      const newTab = window.open();
      newTab.document.body.innerHTML = `<img src="${blobUrl}" style="height: 100vh;">`;
      newTab.document.body.style["text-align"] = "center";
    } else if (["pdf"].includes(suffix)) {
      const newTab = window.open();
      newTab.document.body.innerHTML = `<embed src="${blobUrl}" type="application/pdf" width="100%" height="100%" />`;
      newTab.document.body.style["text-align"] = "center";
    } else {
      var downloadLink = document.createElement("a");

      downloadLink.href = blobUrl;
      downloadLink.download = filename;

      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }
};

const b64toBlob = (b64Data) => {
  const contentType = b64Data.split(";")[0].split(":")[1];
  const byteCharacters = // Buffer.from(b64Data, "base64");
    atob(b64Data.substr(`data:${contentType};base64,`.length));
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
    const slice = byteCharacters.slice(offset, offset + 1024);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const getDescription = (description) => {
  var descriptionWithNoStyle = description?.replace(/<style.*?<\/style>/g, "");
  var descriptionWithNoHtml = descriptionWithNoStyle?.replace(
    /(<([^>]+)>)/gi,
    ""
  );
  const nbspRegEx = /((&nbsp;))*/gim;
  const noNbsp = descriptionWithNoHtml?.replace(nbspRegEx, "");

  return noNbsp || "";
};

export const sortListFirstHeb = (a, b) => {
  const isHebrewA = /^[\u0590-\u05FF]/.test(a.label);
  const isHebrewB = /^[\u0590-\u05FF]/.test(b.label);

  if (isHebrewA && !isHebrewB) {
    return -1;
  } else if (!isHebrewA && isHebrewB) {
    return 1;
  } else {
    return a?.label?.localeCompare(b.label);
  }
};

export const getCurrentDateTime = () => {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const year = String(now.getFullYear()).slice(-2); // Get last two digits of the year
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};

export const isAcceptedFormat = (file, accept) => {
  if (!accept) return false;

  if (typeof accept === "string") {
    // Handle single format
    return file.name
      .toLowerCase()
      .endsWith(accept.substring(accept.indexOf("/") + 1).toLowerCase());
  } else if (Array.isArray(accept)) {
    // Handle multiple formats
    return accept.some((format) => {
      return file.name
        .toLowerCase()
        .endsWith(format.substring(format.indexOf("/") + 1).toLowerCase());
    });
  }
  return false;
};

export const isUrl = (value) => {
  try {
    // If the value starts with a protocol, validate it as a URL
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch (e) {
    // If no protocol, use a regex to validate domain-like structures
    const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return domainRegex.test(value);
  }
};

export const getErrorMessage = (response, text) => {
  if (response?.data.message === "jwt expired") {
    return `error:error_jwt expired`;
  }
  return response?.status === 400 || response?.status === 500
    ? response?.data?.FORM?.InterfaceErrors?.text
    : text;
};
